import { render } from "./ReturnRequestInfo.vue?vue&type=template&id=644e4583&scoped=true"
import script from "./ReturnRequestInfo.vue?vue&type=script&lang=js"
export * from "./ReturnRequestInfo.vue?vue&type=script&lang=js"

import "./ReturnRequestInfo.vue?vue&type=style&index=0&id=644e4583&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644e4583"]])

export default __exports__